(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artvint-image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('av-image-banner')) {
    customElements.define('av-image-banner', class extends HTMLElement {
      connectedCallback() {
        // Defer until children exist when the custom element is already registered.
        this.initTimer = setTimeout(() => this.init(), 0);
      }
      init() {
        this.highlightTitle();
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        const controls = this.querySelector('.av-banner__controls');
        if (controls) controls.hidden = this.slides.length < 2;
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.counter = this.querySelector('[data-counter]');
        this.status = this.querySelector('[data-status]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.querySelector('.av-banner__controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
        this.pauseButton?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.updatePause();
          this.schedule();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          this.editorSelected = true;
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index, false);
          this.schedule();
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
        this.updatePause();
        this.schedule();
      }
      highlightTitle() {
        const title = this.querySelector('.av-banner__title');
        if (!title) return;
        // Restore plain text before reconnecting or updating the highlight.
        title.querySelectorAll('.av-banner__glow-word').forEach(span => span.replaceWith(document.createTextNode(span.textContent)));
        title.normalize();
        const phrase = (title.dataset.glowPhrase || '').trim();
        if (title.dataset.glowEnabled !== 'true' || !phrase) return;
        const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const index = node.textContent.toLowerCase().indexOf(phrase.toLowerCase());
          if (index < 0) continue;
          const match = node.splitText(index);
          match.splitText(phrase.length);
          const span = document.createElement('span');
          span.className = 'av-banner__glow-word';
          match.replaceWith(span);
          span.append(match);
          const accent = document.createElement('span');
          accent.className = 'av-banner__glow-accent';
          accent.setAttribute('aria-hidden', 'true');
          span.append(accent);
          break;
        }
      }
      show(index, announce) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === this.index);
          slide.setAttribute('aria-hidden', String(i !== this.index));
          if (i === this.index) slide.querySelector('img')?.setAttribute('loading', 'eager');
        });
        this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
        if (announce) this.status.textContent = `Image ${this.index + 1} of ${this.slides.length}`;
        this.schedule();
      }
      updatePause() {
        if (!this.pauseButton) return;
        this.pauseButton.textContent = this.paused ? 'Play' : 'Pause';
        this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden) return;
        // Start fetching the next image before its transition.
        this.slides[(this.index + 1) % this.slides.length].querySelector('img')?.setAttribute('loading', 'eager');
        this.timer = setTimeout(() => this.show(this.index + 1, false), Number(this.dataset.interval) || 5000);
      }
      disconnectedCallback() {
        clearTimeout(this.initTimer);
        clearTimeout(this.timer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
